import React from "react"
import axios from "../helpers/axios";
import moment from 'moment';

import { TextField } from "@material-ui/core";
import { Table, TableRow, TableBody, TableCell, TableHead, Paper, TableContainer } from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import SearchIcon from '@material-ui/icons/Search';

import CircularProgress from '@material-ui/core/CircularProgress';

import config from '../config/app-config.json';

class LicenseForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      flag: undefined,
      data: undefined,
      edited: undefined,
      machine_id: '',
      machine_type: ''
    }

    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleChangemachineId = this.handleChangemachineId.bind(this);
    this.handleChangemachineType = this.handleChangemachineType.bind(this);
    this.handleNewRowMachineId = this.handleNewRowMachineId.bind(this);
    this.handleNewRowMachineType = this.handleNewRowMachineType.bind(this);
    this.handleDeactivate = this.handleDeactivate.bind(this);
    this.getLicences = this.getLicences.bind(this);
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.save = this.save.bind(this);
  }



  async getLicences() {
    this.setState({ loading: true });
    try {
      const { data } = await axios.get(config.serviceUrl + `/brainy_concepts_licencing/${this.state.email}`);
      const licences = {};
      const productsCount = {};
      data
        .sort((a, b) => a.expiration_date > b.expiration_date ? -1 : 1)
        .forEach(l => {
          const key = l.product_id + '#' + l.nt_machine_id;


          if (Object.keys(licences).includes(key)) {
            licences[key].rest.push(l);
          } else {
            if (Object.keys(productsCount).includes(l.product_id)) {
              productsCount[l.product_id]++;
            } else {
              productsCount[l.product_id] = 1;
            }
            licences[key] = { main: l, rest: [] };
          }
        })

      this.setState({ data: licences, productsCount, loading: false });
    } catch (err) {
      this.setState({ error: err.message || 'Something went wrong...', loading: false });
    }
  }

  async handleDeactivate(elem) {
    // elem.activated = 0;
    // elem.nt_machine_id = null;
    // console.log('clicked', elem)
    await axios.post(`${config.serviceUrl}/deactivate`, {license_id:elem.license_id});
    await this.getLicences();
  }
  handleChangeEmail(e) {
    this.setState({ email: e.target.value });
  }
  handleChangemachineId(e) {
    this.setState({ machine_id: e.target.value });
  }
  handleChangemachineType(e) {
    this.setState({ machine_type: e.target.value });
  }
  handleNewRowMachineId(e) {
    const newItem = { ...this.state.new };
    newItem.nt_machine_id = e.target.value;
    this.setState({ new: newItem });
  }
  handleNewRowMachineType(e) {
    const newItem = { ...this.state.new };
    newItem.machine_type = e.target.value;
    this.setState({ new: newItem });
  }

  async add() {
    this.setState({ loading: true });
    await axios.post(`${config.serviceUrl}/brainy_concepts_licencing`, { ...this.state.new });

    setTimeout(async ()=>{
      await this.getLicences();
      this.setState({ new: undefined });
    }, 1000);
    // await this.getLicences();
    // this.setState({ new: undefined });
  }

  async delete(license_id) {
    await axios.delete(`${config.serviceUrl}/brainy_concepts_licencing`, { data: { license_id } });
    await this.getLicences();
  }

  async save() {
    this.setState({ loading: true });
    const { edited, machine_id, machine_type } = this.state;

    const licenceKey = Object.keys(this.state.data).find(e => this.state.data[e].main.license_id === edited);
    const licence = this.state.data[licenceKey];

    const rest = licence.rest.map(r => r.license_id);

    const body = {
      license_ids: [edited, ...rest].join("','"),
      nt_machine_id: machine_id,
      nt_machine_type: machine_type
    };
    await axios.put(`${config.serviceUrl}/brainy_concepts_licencing`, body);

    setTimeout(async ()=>{
      await this.getLicences();
      this.setState({ edited: undefined, machine_id: '', machine_type:'', flag: undefined });
    }, 1000);

    // await this.getLicences();
    // this.setState({ edited: undefined, machine_id: '' });
  }

  render() {
    const newRow = this.state.new;
    return <>
      <h2><img src={process.env.PUBLIC_URL + '/logo.png'} width="70" alt="Brainy concepts" />Manage Licenses</h2>
      {this.state.error && <p style={{ color: 'red' }}>{this.state.error}</p>}
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <TextField
          label="Enter email"
          variant="outlined"
          style={{ flexGrow: '1', marginBottom: '20px' }}
          value={this.state.email}
          onChange={this.handleChangeEmail}
          onKeyPress={(ev) => ev.key === 'Enter' ? this.getLicences() : null}
        />
        {this.state.loading ? <CircularProgress size={20} style={{ margin: '15px' }} /> :
          <SearchIcon style={{ margin: '15px' }} onClick={this.getLicences} />
        }
      </div>
      {this.state.data ?
        Object.keys(this.state.data).length > 0 ?
          <TableContainer component={Paper} style={{ overflow: 'visible' }}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="right">License ID</TableCell>
                  <TableCell align="center">Product ID</TableCell>
                  <TableCell align="center">One-Time Pin</TableCell>
                  <TableCell >Machine ID</TableCell>
                  <TableCell >Machine Name</TableCell>
                  <TableCell>Activated</TableCell>
                  <TableCell>De-Activate</TableCell>
                  <TableCell align="right">Creation Date</TableCell>
                  <TableCell align="right">Expiration Date</TableCell>
                  <TableCell style={{ width: '320px' }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.keys(this.state.data).map((key) => {
                  const row = this.state.data[key].main;
                  const main = (
                    <TableRow key={row.license_id}>
                      <TableCell align="right" component="th" scope="row">
                        {row.license_id}
                      </TableCell>
                      <TableCell align="center">{row.product_id}</TableCell>
                      <TableCell>{row.one_time_pin}</TableCell>
                      <TableCell >
                        {this.state.flag === row.license_id+'+'+'MachineId' ?
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <TextField
                              label="Machine ID"
                              variant="outlined"
                              style={{ flexGrow: '1' }}
                              value={this.state.machine_id}
                              onChange={this.handleChangemachineId}
                            />
                            <CheckIcon
                              style={{ margin: '0 15px', color: 'green', cursor: 'pointer' }}
                              onClick={() => this.save()}
                            />
                            <ClearIcon
                              style={{ opacity: '0.5', cursor: 'pointer' }}
                              onClick={() => this.setState({ edited: undefined, machine_id: '', machine_type: '', flag: undefined })}
                            />
                          </div>
                          : <>
                            {row.nt_machine_id} {this.state.data[key].rest.length > 0 ? '(+' + this.state.data[key].rest.length + ')' : ''}
                            {(!row.nt_machine_id || row.nt_machine_id.length <= 32) && <EditIcon
                              style={{ margin: '0 15px', fontSize: '18px', cursor: 'pointer' }}
                              onClick={() => this.setState({ edited: row.license_id, flag: row.license_id+'+'+'MachineId', machine_id: row.nt_machine_id, machine_type:row.machine_type })}
                            />}
                          </>
                        }
                      </TableCell>
                      <TableCell >
                        {this.state.flag === row.license_id+'+'+'MachineType' ?
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <TextField
                              label="Machine Name"
                              variant="outlined"
                              style={{ flexGrow: '1' }}
                              value={this.state.machine_type}
                              inputProps={{ maxLength: 100 }}
                              onChange={this.handleChangemachineType}
                            />
                            <CheckIcon
                              style={{ margin: '0 15px', color: 'green', cursor: 'pointer' }}
                              onClick={() => this.save()}
                            />
                            <ClearIcon
                              style={{ opacity: '0.5', cursor: 'pointer' }}
                              onClick={() => this.setState({ edited: undefined, machine_id: '', machine_type: '', flag: undefined })}
                            />
                          </div>
                          : <>
                            {row.machine_type} {this.state.data[key].rest.length > 0 ? '(+' + this.state.data[key].rest.length + ')' : ''}
                            {(!row.machine_type || row.machine_type.length <= 100) && <EditIcon
                              style={{ margin: '0 15px', fontSize: '18px', cursor: 'pointer' }}
                              onClick={() => this.setState({ edited: row.license_id, flag: row.license_id+'+'+'MachineType', machine_id: row.nt_machine_id, machine_type:row.machine_type })}
                            />}
                          </>
                        }
                      </TableCell>
                      <TableCell>{row.activated ? 'YES' : 'NO'}</TableCell>
                      <TableCell>
                        {row.activated ? <button className="btn" variant="contained" color="primary" onClick={()=> this.handleDeactivate(row).then()}>deactivate</button>:null}
                      </TableCell>
                      <TableCell align="right">{moment(row.date_created).format('lll')}</TableCell>
                      <TableCell align="right">{moment(row.expiration_date).format('lll')}</TableCell>
                      <TableCell>
                        {this.state.productsCount[row.product_id] === 1 && !this.state.new &&
                          <button className="btn" variant="contained" color="primary" onClick={() => this.setState({ new: { ...row } })}>
                            <AddIcon style={{ cursor: 'pointer', fontSize: '20px', verticalAlign: 'bottom' }} />
                    License a Second Machine
                        </button>
                        }
                      </TableCell>
                    </TableRow>
                  )
                  const rest = this.state.data[key].rest.map(row => (
                    <TableRow style={{ opacity: '0.9' }} key={row.license_id}>
                      <TableCell align="right" component="th" scope="row">
                        {row.license_id}
                      </TableCell>
                      <TableCell align="center">{row.product_id}</TableCell>
                      <TableCell>{row.one_time_pin}</TableCell>
                      <TableCell >{row.nt_machine_id}</TableCell>
                      <TableCell >{row.machine_type}</TableCell>
                      <TableCell>{row.activated ? 'YES' : 'NO'}</TableCell>
                      <TableCell>
                      {row.activated ? <button className="btn" variant="contained" color="primary" onClick={()=> this.handleDeactivate(row).then()}>deactivate</button> : null}
                      </TableCell>
                      <TableCell align="right">{moment(row.date_created).format('lll')}</TableCell>
                      <TableCell align="right">{moment(row.expiration_date).format('lll')}</TableCell>
                      <TableCell>
                        <DeleteForeverIcon
                          style={{ cursor: 'pointer', fontSize: '20px', verticalAlign: 'bottom' }}
                          onClick={() => this.delete(row.license_id)}
                        />
                      </TableCell>
                    </TableRow>
                  ));

                  return <React.Fragment key={key}>
                    {main}
                    {rest}
                  </React.Fragment>
                }
                )}
                {newRow &&
                  <TableRow>
                    <TableCell align="right" component="th" scope="row"></TableCell>
                    <TableCell align="center">{newRow.product_id}</TableCell>
                    <TableCell >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <TextField
                          label="Machine ID"
                          variant="outlined"
                          style={{ flexGrow: '1' }}
                          value={newRow.nt_machine_id}
                          onChange={this.handleNewRowMachineId}
                        />
                        <TextField
                          label="Machine Name"
                          variant="outlined"
                          style={{ flexGrow: '1' }}
                          value={newRow.machine_type}
                          inputProps={{ maxLength: 100 }}
                          onChange={this.handleNewRowMachineType}
                        />
                        <CheckIcon
                          style={{ margin: '0 15px', color: 'green', cursor: 'pointer' }}
                          onClick={() => this.add()}
                        />
                        <ClearIcon
                          style={{ opacity: '0.5', cursor: 'pointer' }}
                          onClick={() => this.setState({ new: undefined })}
                        />
                      </div>
                    </TableCell>
                    <TableCell align="right">{moment(newRow.date_created).format('lll')}</TableCell>
                    <TableCell align="right">{moment(newRow.expiration_date).format('lll')}</TableCell>
                    <TableCell style={{ width: '50px' }}></TableCell>
                  </TableRow>
                }
              </TableBody>
            </Table>
          </TableContainer>
          : <p style={{ padding: 20, textAlign: 'center' }}>No License Found for Email Address Entered!</p>
        : null}
    </>
  }
}


export default LicenseForm
